import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CopyButton({ text, label }) {

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(text);
            alert("Texto copiado: " + text);
        } catch (err) {
            console.error("Erro ao copiar", err);
        }
    };

    return (
        <button onClick={copiar} className="btn btn-primary btn-sm">
            <FontAwesomeIcon icon={faCopy}/>{label}
        </button>
    );
}

export default CopyButton;